import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 0,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  // O bloco de texto do CardHeader é `flex: 1 1 auto` sem minWidth:0, então o
  // subtítulo `noWrap` não encolhia: em vez de reticências, estourava o header
  // em 36px a 375px e o nome do atendente saía cortado pela borda.
  content: {
    minWidth: 0,
  },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
  const classes = useStyles();

  return (
    <CardHeader
      onClick={onClick}
      classes={{ root: classes.root, content: classes.content }}
      style={{ cursor: "pointer" }}
      titleTypographyProps={{ noWrap: true }}
      subheaderTypographyProps={{ noWrap: true }}
      avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
      title={`${contact.name} #${ticket.id}`}
      subheader={
        ticket.user &&
        `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`
      }
    />
  );
};

export default TicketInfo;
